export const consolidationOrg = {
  base_currency: 'XXX',
  id: 'consolidationOrg',
  name: 'Consolidation',
  is_zenflow: true
}

export const eliminationOrg = {
  base_currency: 'XXX',
  id: 'eliminations',
  name: 'Eliminations',
  is_zenflow: true
}
